import React, {Component} from "react";

class DifferentDesign extends Component{

    render() {
        return(
            <div className="container-fluid">
                基板の種類がいくつあるかを選択してください、複数ある場合は異種面付けとなります。
            </div>
        );
    }
}
export default DifferentDesign;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/DifferentDesign.js